import React, { useState, useRef } from "react"

import * as s from "./Form.module.scss"

import useOnClickOutside from "../../../hooks/click-outside.ts"

import Arrow from "../../../assets/icons/arrow.inline.svg"

export const DropDown = ({ placeholder, value, onChange, options, error }) => {
  const [focused, setFocused] = useState(false)
  const _options = useRef(null)
  const _mobileSelect = useRef(null)
  useOnClickOutside(_options, () => setFocused(false))

  const _mobileSelectOnChange = () => {
    if (_mobileSelect.current.value) {
      if (_mobileSelect.current.value === null) return
      onChange(_mobileSelect.current.value)
    }
  }

  return (
    <div
      className={`${s.InputWrapper} ${focused && s.InputWrapper___focused} ${
        value && !focused && s.InputWrapper___filled
      } ${error && s.InputWrapper___errored}`}
      ref={_options}
    >
      <span className={s.Placeholder}>{placeholder}</span>
      <div className={s.DropDownInner}>
        <div
          className={s.DropDownInner__trigger}
          onClick={() => setFocused(!focused)}
          onKeyPress={() => setFocused(!focused)}
          role="listbox"
          tabIndex="0"
        >
          <span className={s.DropDownInner__value}>
            {value && options.filter(o => o.value === value)[0]?.label}
          </span>
          <div
            className={`${s.DropDownInner__arrow} ${
              focused && s.DropDownInner__arrow___focused
            }`}
          >
            <Arrow />
          </div>
        </div>
      </div>

      {focused && (
        <div className={s.DropDownOptions}>
          {options.map((option, i) => {
            return (
              <div
                className={s.DropDownOptions__option}
                key={i}
                onKeyDown={() => {
                  setFocused(false)
                  onChange(option.value)
                }}
                onClick={() => {
                  setFocused(false)
                  onChange(option.value)
                }}
                role="listbox"
                tabIndex="0"
              >
                <span>{option.label}</span>
              </div>
            )
          })}
        </div>
      )}

      <div className={s.DropDownMobile}>
        <select ref={_mobileSelect} onChange={_mobileSelectOnChange}>
          <option value={null}>{placeholder}</option>
          {options.map((option, i) => (
            <option key={i} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
